import { Box } from '@mui/material'

import ForumIcon from '@mui/icons-material/Forum'
import MyLocationIcon from '@mui/icons-material/MyLocation'
import SecurityIcon from '@mui/icons-material/Security'
import WorkIcon from '@mui/icons-material/Work'

import { t } from 'i18next'

import { Item } from '@pages/LandingPage/components/Item'

import { containerSx, contentSx, itemSx } from './styles'

const Section1 = () => (
  <Box data-testid="features-section-1" sx={containerSx}>
    <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" sx={contentSx}>
      <Box gridColumn={itemSx}>
        <Item
          variant="blue"
          title={t('Precise Matchmaking')}
          subtitle={t(
            'Find the perfect tech solutions and partners effortlessly with our user-friendly interface and precise matchmaking, connecting you with providers that are a perfect fit for your unique needs.'
          )}
          icon={MyLocationIcon}
        />
      </Box>
      <Box gridColumn={itemSx}>
        <Item
          variant="blue"
          title={t('Empowered Decision Making, Privacy & Security')}
          subtitle={t(
            'Take control of your vendor engagements with the ability to accept or decline matches, ensuring meaningful interactions aligned with your objectives, while maintaining privacy and security.'
          )}
          icon={SecurityIcon}
        />
      </Box>
      <Box gridColumn={itemSx}>
        <Item
          variant="blue"
          title={t('Extensive Tech Solution Catalog & Trusted Partner Network')}
          subtitle={t(
            'Explore a comprehensive catalog of cutting-edge tech solutions and connect with trusted partners who have a proven track record of delivering reliable and high-quality results.'
          )}
          icon={WorkIcon}
        />
      </Box>
      <Box gridColumn={itemSx}>
        <Item
          variant="blue"
          title={t('Streamlined Partner Communication')}
          subtitle={t(
            'Streamline your communication with technology partners through our platform, eliminating endless email threads and missed calls, and enabling direct collaboration for clear and timely communication.'
          )}
          icon={ForumIcon}
        />
      </Box>
    </Box>
  </Box>
)

export { Section1 }
